import { ajaxPostJson } from './ajax';

export const queryPlatformByHost = (params) => {
  return ajaxPostJson(`/user/queryPlatformByHost`, params, 'BaseApi3');
};